import {DateMask} from "./DateMask";

export class JqueryValidator {

    static define() {
        // Birthdate
        jQuery.validator.addMethod("birthdate", function (value, element) {
            return DateMask.isFulldateValid(value);
            // return this.optional(element) || (parseFloat(value) > 0);
        }, "Formát data není správný");

        jQuery.validator.addMethod("birthdate_age_restriction", function (value, element) {
            const isValid = DateMask.isValidByAgeRestriction(value);

            return isValid;
        }, "Musí ti být nejméně 13 let");

        jQuery.validator.addMethod("zip_code", function (value, element) {
            if(value.length == 0) {
                return true;
            }

            const isValid = validator.isPostalCode(value, 'CZ');

            return isValid;
        }, "PSČ není validní");
    }

}
